import { Connection } from '@solana/web3.js';
import type { Chain } from 'viem/chains';

const clients = new Map<number, Connection>();

export function getConnection(chain: Chain): Connection {
  const cached = clients.get(chain.id);
  if (cached) return cached;

  const client = new Connection(chain.rpcUrls.default.http[0]!);
  clients.set(chain.id, client);
  return client;
}
